class SwishController extends AbstractIntegrationController
	@register()
	@inject '$uibModal',
		'configuration'
		'configurationOptions'
		'IntegrationRepository'

	integrationId: 'swish'

	initialize: ->
		@ensureObjectsInConfiguration @configuration, ['shops']

		@defaultId = null
		@configuration.default ?=
			shop_id: @defaultId
			merchant_id: null

	afterDisconnect: ->
		@configuration = {}

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data

	afterDisconnect: ->
		@configuration = {}

	showModal: ->
		@$uibModal
			.open
				templateUrl: '@app/integration/swish/modals/swish.shop-select.modal.view.html'
				size: 'sm'
				bindToController: true
				controllerAs: 'shopSelectModal'
				controller: ($uibModalInstance, ShopRepository, configuration) ->
					$onInit: ->
						@modal = $uibModalInstance
						@shops = []
						@configuration = configuration

					search: (term) ->
						query = ShopRepository.createQuery()
						query
							.sortBy 'name', 'ASC'
							.withoutAnyRelations()
							.criteria 'id', '=', term
							.or 'name', 'LIKE', "%#{term}%"

						if !_.isEmpty(@configuration.shops)
							query.criteria 'id', 'NOT IN', _.pluck(@configuration.shops, 'shop_id').join(',')

						ShopRepository
							.getEntities query
							.then (shops) =>
								@shops = shops
				resolve:
					configuration: => @configuration
			.result
			.then (shop) =>
				@addShop(shop)

	addShop: (shop) ->
		@mainForm.$setDirty()
		@configuration.shops[shop.id] =
			shop_id: shop.id
			shop_name: shop.name
			merchant_id: null

	removeShop: (shop) ->
		if shop.shop_id == @defaultId
			return

		delete @configuration.shops[shop.shop_id]

		@mainForm.$setDirty()
